import { Component } from 'react';
import '../../../../styles/components/auth.scss';
import { Loader2, Lock, MoveRight } from 'lucide-react';

import { withRouter } from '../../../../hoc/withRouter';
import { resetPassword } from './services/authService';
import { toast } from 'react-toastify';
import i18n from '../../../../i18n';

class ResetPasswordNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: null,
      showPassword: false,
      confirmPassword: null,
      showConfirmPassword: false,
      isSubmitting: false,
      errors: {},
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  toggleVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field],
    }));
  };

  validateForm = () => {
    const errors = {};
    const { password, confirmPassword } = this.state;

    if (!password) errors.password = 'password is required';
    if (password && password.length < 8) {
      errors.password = 'Password must be at least 8 characters';
    }
    if (!confirmPassword) errors.confirmPassword = 'confirmPassword (English) is required';
    if (password !== confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  renderFieldError = (fieldName) => {
    if (this.state.errors[fieldName]) {
      return <div className="field-error">{this.state.errors[fieldName]}</div>;
    }
    return null;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }
    const { password, confirmPassword } = this.state;
    const token = this.props.params.token;

    this.setState({ isSubmitting: true });
    try {
      const result = await resetPassword({
        reset_token: token,
        password: password,
        password_confirmation: confirmPassword,
      });

      const { response } = result;
      // Check if verification is required (OTP/email)
      toast.success(response?.message || 'Reset Password successful!');
      this.props.navigate(`/login`);
    } catch (error) {
      toast.error(error.message || 'Reset Password failed. Please try again.');
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  handleLogin = () => {
    this.props.navigate(`/login`);
  };

  render() {
    const { password, showPassword, confirmPassword, showConfirmPassword, errors, isSubmitting } =
      this.state;

    return (
      <div className="register-container">
        <div className="login-left-section">
          <div className="auth-content">
            <div className="accent-line"></div>
            <h1 className="title">{i18n.t('reset_password_banner_title')}</h1>
            <p className="subtitle-l2">{i18n.t('reset_password_banner_subtitle')}</p>
          </div>
        </div>

        <div className="login-right-section">
          <div className="login-card">
            <h3 className="welcome-title">{i18n.t('create_a_new_password')}</h3>
            <p className="welcome-subtitle">{i18n.t('reset_password_card_subtitle')}</p>

            <form onSubmit={this.handleSubmit}>
              {/* Password  */}
              <div className="form-group-l2">
                <label htmlFor="password">{i18n.t('password')}</label>
                <div className="input-wrapper">
                  <Lock strokeWidth={1.5} className="input-icon-l2" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={password}
                    onChange={this.handleInputChange}
                    placeholder="••••••••"
                    className={`form-input-l2 ${errors?.password ? 'error' : ''}`}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => this.toggleVisibility('showPassword')}
                    aria-label="Toggle password visibility"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {!showPassword ? (
                        <>
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </>
                      ) : (
                        <>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                {this.renderFieldError('password')}
              </div>
              {/* Confirm Password */}
              <div className="form-group-l2 border-wrapper">
                <label htmlFor="confirmPassword">{i18n.t('confirm_password')}</label>
                <div className="input-wrapper">
                  <Lock strokeWidth={1.5} className="input-icon-l2" />
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={this.handleInputChange}
                    placeholder="••••••••"
                    className={`form-input-l2 ${errors?.confirmPassword ? 'error' : ''}`}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => this.toggleVisibility('showConfirmPassword')}
                    aria-label="Toggle password visibility"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {showConfirmPassword ? (
                        <>
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </>
                      ) : (
                        <>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                {this.renderFieldError('confirmPassword')}
              </div>

              <div className="register-buttons ">
                <button type="submit" disabled={isSubmitting} className="button1 button1-gradient ">
                  {i18n.t('reset_password')}
                  {isSubmitting ? (
                    <Loader2 className="animate-spin" size={18} />
                  ) : (
                    <MoveRight strokeWidth={1.5} />
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ResetPasswordNew);
